(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	ngModule.directive('storeDetail', function ($Stores, $rootScope, $firebaseObject, $state, $timeout) {

		return {
            scope: {
				store: '='
			},
			templateUrl: 'directives/storeDetail/section.html',
			controller: function($scope, $state, $timeout) {

                $scope.filterApprovedProducts = function(prod){
                    if(prod.design_status === 'approved'){
                        return true;
                    }
                    return false;
                };

                $scope.filterUnapprovedProducts = function(prod){
                    if(prod.design_status === 'unapproved' || prod.design_status === undefined || prod.design_status === null){
                        return true;
                    }
                    return false;
                };

                $scope.filterRejectedProducts = function(prod){
                    if(prod.design_status === 'rejected'){
                        return true;
                    }
                    return false;
                };

                $scope.resetToUnreviwed = function(product) {

                    var index = _.findIndex($scope.store.products, {id:product.id});
                    $scope.store.products[index].design_status = 'unapproved';
                    $scope.save();
                };

                $scope.edit = true;

                $scope.saveMessageVisible = false;

                $scope.closeAlert = function() {

                    $scope.saveMessageVisible = false;

                };

                $scope.save = function() {

                    console.log('saving');

                    if($scope.store.$id){
                        console.log('has id, saving');
                        $scope.store.$save().then(function() {
                            $scope.saveMessageVisible = true;
                            $timeout(function() {
                                $scope.closeAlert();
                            }, 4000);
                        });
                    } else {
                        console.log('has no id, creating, going');
                         $Stores.add($scope.store).then(function(newStore) {

                             $state.go('store-detail', {id: newStore.key});

                         });

                    }
                };

                $scope.saveAndClose = function() {
                    $scope.store.$save().then(function(){
                        $state.go('stores');
                    });
                };

                $scope.close = function() {
                    $scope.store.$save().then(function() {
                        $state.go('stores');
                    });
                };

                $scope.init = function() {
                    console.log('init scope store', $scope.store);

                    if(!$scope.store.$id){
                        $scope.store.status = 'draft';
                    }
                };

                $scope.resizeWindow = () => {
                    // $(window).trigger('resize');
                    $timeout( () => {
                        $(window).resize();
                    }, 500);

                };

                $scope.init();
			}
		};

	});

})();
